import React from 'react';
import cc from 'classcat';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".react-list_1-1-2_co-list,\n.react-list_1-1-2_co-list__item,\n.react-list_1-1-2_co-list__link {\n  box-sizing: border-box;\n}\n\n.react-list_1-1-2_co-list {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n.react-list_1-1-2_co-list .react-list_1-1-2_co-list__item {\n  padding: 0 0 4px 0;\n  margin: 0;\n}\n.react-list_1-1-2_co-list .react-list_1-1-2_co-list__item:last-child {\n  padding: 0;\n}\n.react-list_1-1-2_co-list .react-list_1-1-2_co-list__link {\n  display: block;\n  border-radius: 4px;\n  outline: none;\n  cursor: pointer;\n  color: inherit;\n  text-decoration: none;\n  transition-property: background-color, color;\n  transition-duration: 0.2s;\n  transition-timing-function: ease;\n}\n.react-list_1-1-2_co-list .react-list_1-1-2_co-list__link[data-co-disabled], .react-list_1-1-2_co-list .react-list_1-1-2_co-list__link[data-disabled] {\n  cursor: not-allowed;\n  opacity: 0.5;\n  pointer-events: none;\n}\n.react-list_1-1-2_co-list .react-list_1-1-2_co-list__link:hover, .react-list_1-1-2_co-list .react-list_1-1-2_co-list__link[data-co-hover], .react-list_1-1-2_co-list .react-list_1-1-2_co-list__link:focus, .react-list_1-1-2_co-list .react-list_1-1-2_co-list__link[data-co-focus], .react-list_1-1-2_co-list .react-list_1-1-2_co-list__link[data-focus] {\n  background-color: var(--gray-200);\n}\n.react-list_1-1-2_co-list .react-list_1-1-2_co-list__link:active, .react-list_1-1-2_co-list .react-list_1-1-2_co-list__link[data-co-active], .react-list_1-1-2_co-list .react-list_1-1-2_co-list__link[data-active] {\n  background-color: var(--primary-200);\n  color: var(--primary-600);\n}\n\n.react-list_1-1-2_co-list.react-list_1-1-2_co-list--divided > .react-list_1-1-2_co-list__item {\n  padding: 4px 0;\n  border-bottom: 1px solid var(--gray-300);\n}\n.react-list_1-1-2_co-list.react-list_1-1-2_co-list--divided > .react-list_1-1-2_co-list__item:first-child {\n  padding-top: 0;\n}";
var styles = {
  "co-list": "react-list_1-1-2_co-list",
  "co-list__item": "react-list_1-1-2_co-list__item",
  "co-list__link": "react-list_1-1-2_co-list__link",
  "co-list--divided": "react-list_1-1-2_co-list--divided"
};
styleInject(css);

const List = ({
  className = "",
  forwardedRef,
  divided,
  ...props
}) => {
  const classStyles = cc([styles["co-list"], {
    [styles["co-list--divided"]]: divided
  }, className]);
  return React.createElement("ul", _extends({
    className: classStyles,
    ref: forwardedRef
  }, props, {
    "data-co-name": "List",
    "data-co-version": "1.1.2",
    "data-co-project": "cobalt"
  }));
};

const Item = ({
  className = "",
  forwardedRef,
  ...props
}) => {
  const classes = cc([styles["co-list__item"], className]);
  return React.createElement("li", _extends({
    className: classes,
    ref: forwardedRef
  }, props));
};

const SpanEl = ({
  children,
  className,
  forwardedRef,
  ...props
}) => {
  return React.createElement("span", _extends({
    className: className,
    ref: forwardedRef,
    "data-co-disabled": true
  }, props), children);
};

const LinkEl = ({
  children,
  className,
  forwardedRef,
  selected,
  ...props
}) => {
  return React.createElement("a", _extends({
    className: className,
    ref: forwardedRef,
    "data-co-active": selected || undefined
  }, props), children);
};

const ClickableItem = ({
  className = "",
  disabled,
  selected,
  onClick,
  ...props
}) => {
  const classes = cc([styles["co-list__link"], className]);
  return React.createElement("li", {
    className: styles["co-list__item"]
  }, disabled ? React.createElement(SpanEl, _extends({
    className: classes
  }, props)) : React.createElement(LinkEl, _extends({
    className: classes,
    onClick: onClick,
    selected: selected
  }, props)));
};

export default List;
export { ClickableItem, Item };
